import { Button } from '@/components/ui/button';
import { VERIFICATION_CAST } from './cast';
import { useVerificationStudio } from './VerificationStudioContext';

export function VerificationStudioBanner() {
  const { enabled, disable } = useVerificationStudio();
  if (!enabled) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-[80] flex -translate-x-1/2 items-center gap-3 rounded-full border bg-background/95 px-4 py-2 shadow-lg backdrop-blur">
      <p className="text-sm">
        Sample workspace · {VERIFICATION_CAST.organization.name}
      </p>
      <Button type="button" size="sm" variant="outline" onClick={disable}>
        Exit
      </Button>
    </div>
  );
}
